export default "__VITE_ASSET__Cr2cupww__"